import { Quota } from '../@types/quota'
import api from '../utils/api'

export const quotaService = {
	getQuotas() {
		return api.get<void, Quota[]>('/v1/quotas')
	},
}
